export const ADD_TAG_FILTER = 'ADD_TAG_FILTER';
export const REMOVE_TAG_FILTER = 'REMOVE_TAG_FILTER';

export const SET_TAG_FILTERS = 'SET_TAG_FILTERS';



// WEBPACK FOOTER //
// ./src/actionTypes/filteringActionTypes.js